export const UserPrefix = '/staff'

export const UserPath = {
  Dashboard: '/dashboard',
  Hoardings: '/hoardings',
  Quotations: '/quotations',
  Campaigns: '/campaigns',
  Resources: '/resources',
  Vendors: '/vendors',
  Settings: '/settings',
}
